<template>
    <div>
        <!-- Indicadores do Item do Estoque -->
        <div class="modal fade" id="parmsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-tachometer-alt mr-2"></i>
                            {{ item ? item.search : 'Carregando...' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!grupos" />

                        <template v-else>
                            <div class="accordion" id="accordionGrupos">
                                <div class="card mb-0" v-for="(grupo, igx) in grupos" :key="igx">
                                    <div class="card-header" id="headingOne">
                                        <h2 class="mb-0">
                                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapseGrupo' + igx">
                                                {{ grupo.search }}
                                            </button>
                                        </h2>
                                    </div>

                                    <div :id="'collapseGrupo' + igx" class="collapse" :class="grupos.length == 1 ? 'show' : ''" data-parent="#accordionGrupos">
                                        <div class="card-body">
                                            <button type="button" class="btn btn-primary btn-sm" v-if="!grupo.parm" @click="incluir_parm(grupo)">
                                                <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                                Incluir Parâmetros
                                            </button>
                                            
                                            <template v-else>
                                                <div class="form-row">
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="CMM: Consumo Médio Mensal"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_cmm">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append" v-if="item && item.st_unidade_estoque">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ item.st_unidade_estoque }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="IC: Intervalo de Compra"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_intervalo_compra">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ grupo.parm.in_intervalo_compra == 1 ? 'dia' : 'dias' }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="TMR: Tempo Médio de Ressuprimento"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_tmr">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ grupo.parm.in_tmr == 1 ? 'dia' : 'dias' }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                </div>

                                                <div class="form-row mt-3">
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="ES: Estoque de Segurança"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_estoque_seguranca">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append" v-if="item && item.st_unidade_estoque">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ item.st_unidade_estoque }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="PR: Ponto de Ressuprimento"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_ponto_ressuprimento">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append" v-if="item && item.st_unidade_estoque">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ item.st_unidade_estoque }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="number"
                                                            label="EI: Estoque Ideal"
                                                            :validate="validate"
                                                            v-model="grupo.parm.in_estoque_ideal">
                                                            <template v-slot:buttonposb>
                                                                <div class="input-group-append" v-if="item && item.st_unidade_estoque">
                                                                    <span class="input-group-text" id="basic-addon2">
                                                                        {{ item.st_unidade_estoque }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>    
                                                </div>

                                                <div class="form-row mt-3">
                                                    <div class="col col-12 col-md-4">
                                                        <az-input
                                                            type="select"
                                                            :optionsList="[
                                                                { id: 'A', search: 'A' },
                                                                { id: 'B', search: 'B' },
                                                                { id: 'C', search: 'C' },
                                                            ]"
                                                            optionsData="id"
                                                            label="Curva ABC"
                                                            :validate="validate"
                                                            v-model="grupo.parm.st_curva_abc" />
                                                    </div>    
                                                </div>

                                                <div class="mt-3">
                                                    <az-input 
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        label="Calcular CMM"
                                                        v-model="calc_cmm">
                                                    </az-input>

                                                    <az-submit color="outline-primary" @click="recalcular_parm(grupo.parm)"
                                                        :disabled="!grupo.parm.id_estoque_item_parm">
                                                        Recalcular
                                                    </az-submit>

                                                    <div class="small text-muted">
                                                        Recalcular {{ calc_cmm ? 'CMM, ' : '' }} ES, PR e EI.
                                                    </div>
                                                </div>

                                                <div class="mt-3" v-if="grupo.parm && grupo.parm.id_estoque_item_parm">
                                                    <az-audit-log-button model="estoqueItemParm" :id="grupo.parm.id_estoque_item_parm" />
                                                </div>

                                                <template v-if="false">
                                                    <pre class="alert alert-info">{{ item }}</pre>
                                                    <pre class="alert alert-warning">{{ grupo.parm }}</pre>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <pre v-if="false">{{ grupos }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            grupos: null,
            item: null, 
            validate: false, 
            calc_cmm: false, 
        }
    },

    components: { 
        AzSubmit,
        AzEmptyState,
        AzInput, 
        AzAuditLogButton,
    },

    methods: { 
        recalcular_parm (parm) { 
            this.$util.atualizar(this, { 
                service: 'estoque_item_parms',
                func: 'calcular_parms',
                dados: { 
                    ...parm,
                    calc_cmm: this.calc_cmm,
                },
                callback: res => { 
                    parm.in_estoque_seguranca = res.in_estoque_seguranca;
                    parm.in_estoque_ideal = res.in_estoque_ideal;
                    parm.in_ponto_ressuprimento = res.in_ponto_ressuprimento;

                    if ( this.calc_cmm ) { 
                        parm.in_cmm = res.in_cmm;
                    }
                },
            });
        },

        abrir(item, id_estoque_grupo_local = null) { 
            this.validate = false;
            this.grupos = null; 
            this.item = _.cloneDeep(item);

            let filtros = {};

            if ( id_estoque_grupo_local ) { 
                filtros.where = { id_estoque_grupo_local: id_estoque_grupo_local };
            }

            if ( !this.grupos ) { 
                this.$util.load(this, { 
                    service: 'estoque_grupo_locals',
                    func: 'index',
                    parms: { 
                        id_estoque_item: item.id_estoque_item, 
                        ...filtros, 
                    },
                    loadTo: res => {
                        this.grupos = res;
                    },
                });
            }

            $('#parmsModal').modal('show');
        },

        incluir_parm(grupo) { 
            grupo.parm = { 
                id_estoque_item: null, 
                id_estoque_grupo_local: null,   
                in_cmm: null, 
                in_estoque_ideal: null, 
                in_tmr: null,   
                in_intervalo_compra: null, 
                in_estoque_seguranca: null, 
                in_ponto_ressuprimento: null, 
                st_curva_abc: null, 
            };
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'estoque',
                func: 'salvar_parms',
                dados: { 
                    grupos: this.grupos, 
                    id_estoque_item: this.item.id_estoque_item, 
                },
                modal: 'parmsModal',
                toast: true, 
                callback: res => { 
                    this.$emit('refresh', res);
                }
            });
        }
    }

}
</script>